/**
 * Radix popover collision tuning so floating panels (canvas chat, quick-add menu)
 * position against the full viewport (`document.documentElement`) instead of
 * clipping to overflow-hidden ancestors — matches MessageInput wide entity picker.
 */
export const VIEWPORT_POPOVER_COLLISION_PADDING = {
  top: 12,
  bottom: 12,
  left: 16,
  right: 16,
} as const;

export function getViewportDocumentCollisionBoundary():
  | HTMLElement
  | undefined {
  if (typeof document === "undefined") return undefined;
  return document.documentElement;
}
